import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NotificationSystem from 'react-notification-system';
import loadImage from 'image-promise';

import { loginUser } from '../../actions/user_actions';
import urls from "../../utils/urls";


class LoginForm extends Component {

    constructor(props){
        super(props);

        this.state = {
            passwordRecoverPath: `${urls.SSO_ROOT}/password_reset`,
            username: '',
            password: '',
            button_disabled: false,
            failed_login_shown: false,
            _notificationSystem: null
        }
    }

    _handleInputUsername = (ev) => {
        this.setState({username: ev.target.value.toLowerCase()})
    };

    _handleInputPassword = (ev) => {
        this.setState({password: ev.target.value})
    };

    _handleSubmit = (ev) => {
        ev.preventDefault();

        if(this.state.username === '' || this.state.password === ''){return false;}

        // console.log("--- SUBMISSION ---");
        this.setState({button_disabled: true, failed_login_shown: false});

        // Try to login User
        this.props.loginUser(this.state.username, this.state.password)
    };

    componentDidMount(){
        this.setState({_notificationSystem: this.refs.notificationSystem});
        loadImage('/static/imgs/login/background.jpg').then(() => {
            document.querySelector('.main-login').classList.add('main-login-big-image');
        });
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.user && nextProps.user.username == null){
          if(this.state.failed_login_shown === true){
              this.setState({button_disabled: false});
          }else{
              this.setState({button_disabled: false, failed_login_shown: true});
              this.state._notificationSystem.addNotification({
                  title: 'Error en la contraseña',
                  message: 'Su usuario o contraseña es incorrecto. Por favor, vuelva a intentarlo.',
                  level: 'error',
                  position: 'bc',
                  dismissible: false,
                  onRemove: () => {
                      this.setState({recovery_error: false});
                  }
              });
          }
        }
    }

    render(){

        let disabled = '';
        if (this.state.button_disabled){
            disabled = 'disabled';
        }

        return (
            <div className="valign-wrapper main-login">
                <div className="row login-container text-center">
                    <div className="form-login">
                        <form>
                           <img src="/static/imgs/shell.png" alt="Shell" />
                           <h4 className="text-center">Shell Pricing</h4>
                           <div className="row">
                                <div className="input-field col s12">
                                    <input value={this.state.username}  type="text" placeholder="Ingrese su usuario o email" onChange={this._handleInputUsername} />
                                    <label className="active">Usuario / Email</label>
                                </div>
                                <div className="input-field col s12">
                                   <input value={this.state.password}  type="password" placeholder="Ingrese su contraseña" onChange={this._handleInputPassword} />
                                   <label className="active">Contraseña</label>
                                   <div className="text-right">
                                       <a href={this.state.passwordRecoverPath}>Olvidé mi contraseña</a>
                                   </div>
                                </div>
                                <div className="input-field col s12">
                                    <button type="submit" ref="loginButton"
                                            className={"btn btn-yellow z-depth-0 " + disabled}
                                            onClick={this._handleSubmit} >Ingresar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <NotificationSystem ref="notificationSystem" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({loginUser}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/login/login.js